import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectSavedReportsInitialized, selectSavedReportsLoading} from '../savedReports/savedReports.selectors';
import {
  selectReportsFoldersInitialized,
  selectReportsFoldersLoading
} from '../savedReportsFolders/savedReportsFolders.selectors';
import {selectUsersLoading} from '../users/users.selectors';

export const selectSavedReportsAndFoldersInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectSavedReportsInitialized,
  selectReportsFoldersInitialized,
  (savedReportsLoaded: boolean, reportsFoldersLoaded: boolean) => savedReportsLoaded && reportsFoldersLoaded
);

export const selectSavedReportsAndFoldersLoading: MemoizedSelector<object, boolean> = createSelector(
  selectSavedReportsLoading,
  selectReportsFoldersLoading,
  selectUsersLoading,
  (savedReportsLoading: boolean, reportsFoldersLoading: boolean, userLoading: boolean) => savedReportsLoading || reportsFoldersLoading || userLoading
);
